import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConvList } from '@/components/messenger/ConvList';
import { ChatThread } from '@/components/messenger/ChatThread';
import { CallHistoryList } from '@/components/messenger/CallHistoryList';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import '@/styles/messenger.css';

type Tab = 'chats' | 'calls';

export function MessengerRoute() {
  const { t } = useTranslation();
  const bp = useBreakpoint();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [tab, setTab] = useState<Tab>('chats');

  const isPhone = bp === 'phone';
  const mode: 'list' | 'chat' = isPhone && selectedId ? 'chat' : 'list';

  const onBack = useCallback(() => setSelectedId(null), []);

  return (
    <div className="msg-page" data-mode={mode}>
      <aside className="msg-list-pane">
        <div className="msg-tabs">
          <button
            type="button"
            className={`msg-tab${tab === 'chats' ? ' active' : ''}`}
            onClick={() => setTab('chats')}
          >
            {t('messenger.tab_chats')}
          </button>
          <button
            type="button"
            className={`msg-tab${tab === 'calls' ? ' active' : ''}`}
            onClick={() => setTab('calls')}
          >
            {t('messenger.tab_calls')}
          </button>
        </div>
        {tab === 'chats' ? (
          <ConvList selectedId={selectedId} onSelect={setSelectedId} embedded />
        ) : (
          <CallHistoryList />
        )}
      </aside>
      <ChatThread threadId={selectedId} onBack={onBack} />
    </div>
  );
}
